// Held-bill persistence — "hold" parks the in-progress bill so the operator
// can start a fresh one (e.g. next customer while this one steps away), and
// "recall" brings it back. Backed by IndexedDB (via cachedKey) rather than
// plain React state so a page refresh or crash mid-shift doesn't silently
// drop a customer's order.

import { TransactionItem } from '../types';
import { cachedKey } from './idb';

export interface HeldBillLine extends TransactionItem {
  sentQty?: number;
}

export interface HeldBill {
  id: string;
  label: string;
  items: HeldBillLine[];
  customerName: string;
  table?: string;
  heldAt: number;
}

const heldBillsCache = cachedKey<HeldBill[]>('sconnect.heldBills', []);

export const getHeldBills = (): HeldBill[] => heldBillsCache.get();

export const saveHeldBills = (bills: HeldBill[]): Promise<void> => heldBillsCache.set(bills);
